var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expand-transition',[(_vm.links)?_c('Iframe',{staticClass:"fill-height fill-width",attrs:{"link":_vm.links.roomServiceUrl,"title":"Room Service"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }